import React from 'react';
import PropTypes from 'prop-types';
import styles from './tabItemsImage.module.scss';
import SmartImage from '../../smartImage/smartImage';

function TabItemsImage({ alt, ...imageProps }) {
  return (
    <div className={styles.panelImageWrapper}>
      <SmartImage
        src={imageProps.src}
        alt={alt}
        loading="lazy"
        className={styles.panelImg}
        width={imageProps.width || 729}
        height={imageProps.height || 540}
      />
    </div>
  );
}

TabItemsImage.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default TabItemsImage;
